<template>
  <div class="input-area">
    <div class="single-input-field">
      <p class="input-title">員工帳號</p>
      <div class="custom-input">
        <input
          type="text"
          class="custom-text account"
          :placeholder="'請輸入員工帳號'"
          name="account"
          v-model="account"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="single-input-field">
      <p class="input-title">密碼</p>
      <div class="custom-input">
        <input
          :type="fieldType"
          class="custom-text password"
          :placeholder="'請輸入密碼'"
          name="password"
          v-model="password"
          autocomplete="off"
        />
        <div
          class="icon-icon_sharp-1"
          @click="changeToText"
          v-show="fieldType == 'password'"
        ></div>

        <div
          class="icon-icon_sharp"
          @click="changeToPassword"
          v-show="fieldType == 'text'"
        ></div>
      </div>
    </div>

    <!-- <Recaptcha ref="recaptcha" v-model="recaptchaData" /> -->

    <button class="login-btn custom-btn" @click="validateLogin">登入</button>
  </div>
</template>

<script>
// import Recaptcha from '@/components/Recaptcha/Recaptcha';
import { mapActions } from 'vuex';

export default {
  components: {
    // Recaptcha
  },
  data() {
    return {
      fieldType: 'password',
      account: '',
      password: '',
      recaptchaData: true,
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'width=1400'
      }
    };
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);
  },
  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    ...mapActions('user', ['login']),
    //查看密碼
    changeToText() {
      this.fieldType = 'text';
    },

    //切換回密碼
    changeToPassword() {
      this.fieldType = 'password';
    },
    resetData() {
      this.account = this.rememberedAccount;

      this.password = '';

      this.remember = this.rememberedAccount ? true : false;
    },
    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    },
    validateLogin() {
      if (!this.recaptchaData) {
        alert('請驗證機器人');
        return;
      } else {
        this.login({
          account: this.account,
          password: this.password,
          remember: this.remember,
          recaptcha: this.recaptchaData,
          cb: () => {
            this.resetData();
            this.$router.push({ name: '選擇頁' }).catch(() => {});
          },
          errCb: () => {
            alert('登入失敗,請檢查帳號與密碼是否正確');
            // this.recaptchaData = '';
            // this.$refs.recaptcha.onCaptchaExpired();
          }
        });
      }
    }
  }
};
</script>
